<!-- TimeSlider.vue -->
<template>
  <div class="time-slider">
    <label>
      Time: Next
      <span v-if="displayDays">{{ displayDays }} day<span v-if="displayDays > 1">s</span></span>
      <span v-else>{{ localValue }} hour<span v-if="localValue > 1">s</span></span>
    </label>
    <input
      type="range"
      :min="min"
      :max="max"
      :step="step"
      v-model.number="localValue"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Number,
    default: 72,
  },
});

const emit = defineEmits(['update:modelValue']);

const min = 1; // Minimum value in hours
const max = 336; // Maximum value 2 weeks
const step = 1; // Increment by 1 hour

const localValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    localValue.value = newVal;
  }
);

watch(localValue, (newVal) => {
  emit('update:modelValue', newVal);
});

const displayDays = computed(() => {
  if (localValue.value >= 24) {
    return Math.floor(localValue.value / 24);
  }
  return null;
});
</script>

<style scoped>
.time-slider {
  display: flex;
  flex-direction: column;
}

.time-slider label {
  margin-bottom: 8px;
  font-weight: bold;
}

.time-slider input[type='range'] {
  width: 100%;
}
</style>
